import {createTheme} from '@material-ui/core'

export const theme = createTheme({
  typography: {
    fontFamily: "'Poppins', 'Helvetica', 'Arial', sans-serif"
  },
  palette: {
    mode: 'light',
    primary: {
      main: '#f74d0a',
      light: '#feede4'
    },
    secondary: {
      main: '#feede4',
      light: '#fff9f5'
    }
  }
})
